import {
  INTERNAL_OPERATION_TYPES,
  TRANSACTION_TYPES,
  OPERATION_TYPES,
} from "@/shared/utils/constants/coinsConstants";

function initState() {
  return {
    // Transaction Types
    transactionTypes: TRANSACTION_TYPES,
    operationTypes: OPERATION_TYPES,
  };
}

const state = initState();

const mutations = {};

const actions = {
  HISTORY_USERS(
    { rootState, rootGetters },
    {
      accountTypeIds = [1, 7],
      coinId,
      limit,
      offset,
      date_from,
      date_to,
      typesId,
    },
  ) {
    return new Promise((resolve, reject) => {
      const filters = {
        coins_ids: coinId ? [coinId] : null,
        from: date_from,
        to: date_to,
        transaction_types_ids: typesId,
        account_type_ids: accountTypeIds,
        coinhold_id: null,
        type: "wallet",
        coin_code: null,
      };

      this.$apiService()
        .post(
          `/history/users${
            rootGetters["auth/isSub"]
              ? `?username=${rootState.auth.username}`
              : ""
          }`,
          {
            ...filters,
            limit,
            offset,
          },
        )
        .then((data) => {
          if (data.wallets) {
            const result = data.wallets
              ? data.wallets.map((i) => {
                  if (INTERNAL_OPERATION_TYPES.includes(i.type)) {
                    i.status = 2;
                    return i;
                  }
                  return i;
                })
              : [];
            resolve(data, {
              ...data,
              wallets: result,
            });
          } else {
            reject(data.error);
          }
        })
        .catch((e) => {
          console.error("HISTORY_USERS:", e);
          reject(e.response.data.error);
        });
    });
  },

  // Return array with all user addresses (in all networks) for the coin
  async GET_PROFILE_ADDRESS({ rootState, rootGetters }, { coin }) {
    try {
      return await this.$apiService().endpointApi.post(
        `/profile/address${
          rootGetters["auth/isSub"] ? `/${rootState.auth.accountID}` : ""
        }`,
        {
          coin_id: coin,
        },
      );
    } catch (error) {
      console.error("GET_PROFILE_ADDRESS:", { ...error });
      return null;
    }
  },
};

const getters = {
  walletsBalanceByCoin(state, getters, rootState) {
    return Object.values(rootState.coinService.coinBalances).reduce(
      (acc, cur) => {
        acc[cur.coin_id] =
          rootState.coinService.coinBalances[cur.coin_id].wallet_balance;
        return acc;
      },
      {},
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
